<script lang="ts" setup>
/* eslint-disable vue/max-len */
// Airmail-style front face of the envelope. A solid color field
// (themed via `currentColor` → `--env-color`) overlaid with a
// repeating diagonal stripe pattern and a Giftly-G postmark. The
// addressing text in `Envelope.vue` is layered on top of this via
// position: absolute.
</script>

<template>
  <svg
    class="env-front-art"
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <!-- Outer flood — same hue as the body, sits underneath the clip
         so the corners read solid no matter how the SVG is scaled. -->
    <rect width="320" height="320" fill="currentColor"/>

    <g clip-path="url(#env-front-clip)">
      <rect width="320" height="320" fill="currentColor"/>

      <!-- Diagonal stripe pattern. Each line is the same orientation
           (top-right to bottom-left) at 23–24px spacing, 8px stroke,
           20% opacity. Drawn through a frame mask so the stripes only
           appear on the outer band (the inner 293×293 area stays
           clean for the addressing). -->
      <mask
        id="env-front-frame-mask"
        style="mask-type: alpha;"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="320"
        height="322"
      >
        <path
          d="M320 -0.185547V320.186H0V-0.185547H320ZM13.7422 306.62H306.258V13.3799H13.7422V306.62Z"
          fill="#FFBDBD"
        />
      </mask>
      <g mask="url(#env-front-frame-mask)">
        <line
          opacity="0.2"
          x1="528.828"
          y1="-166.918"
          x2="-1.17157"
          y2="363.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="505.828"
          y1="-166.918"
          x2="-24.1716"
          y2="363.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="482.828"
          y1="-166.918"
          x2="-47.1716"
          y2="363.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="436.828"
          y1="-167.172"
          x2="-93.1716"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="459.828"
          y1="-167.172"
          x2="-70.1716"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="413.828"
          y1="-167.172"
          x2="-116.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="390.828"
          y1="-167.172"
          x2="-139.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="367.828"
          y1="-167.172"
          x2="-162.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="344.828"
          y1="-167.172"
          x2="-185.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="321.828"
          y1="-167.172"
          x2="-208.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="298.828"
          y1="-167.172"
          x2="-231.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="252.828"
          y1="-167.172"
          x2="-277.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="275.828"
          y1="-167.172"
          x2="-254.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="229.828"
          y1="-167.172"
          x2="-300.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="206.828"
          y1="-167.172"
          x2="-323.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="183.828"
          y1="-167.172"
          x2="-346.172"
          y2="362.828"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="552.828"
          y1="-166.918"
          x2="21.8284"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="576.828"
          y1="-166.918"
          x2="45.8284"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="600.828"
          y1="-166.918"
          x2="69.8284"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="624.828"
          y1="-166.918"
          x2="93.8284"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="648.828"
          y1="-166.918"
          x2="117.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="672.828"
          y1="-166.918"
          x2="141.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="696.828"
          y1="-166.918"
          x2="165.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="720.828"
          y1="-166.918"
          x2="189.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="744.828"
          y1="-166.918"
          x2="213.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="768.828"
          y1="-166.918"
          x2="237.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
        <line
          opacity="0.2"
          x1="792.828"
          y1="-166.918"
          x2="261.828"
          y2="364.082"
          stroke="black"
          stroke-width="8"
        />
      </g>
    </g>

    <!--
      Postmark intentionally omitted here — `Envelope.vue` overlays
      the existing `postmark.svg` asset on top of this art, which
      stays a single source of truth for the stamp graphic.
    -->

    <defs>
      <clipPath id="env-front-clip">
        <rect width="320" height="320" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
.env-front-art {
  display: block;
  height: 100%;
  width: 100%;
}
</style>
